import styled from "@emotion/styled";
import { AppColors } from "../../constants/colors/app-colors";

export const FormValidationMessage = styled.span({
    color: AppColors.text.red.primary,
})